import numeral from "numeral";

export const wrapNumber = (num: number) => numeral(num).format("#,#");

export default wrapNumber;
